import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes'
import { IOdataRequest } from 'api/odata.types'
import queryString from 'query-string'
import { isNotNullOrUndefined } from 'shared/gaurds'
import { datahubApi } from 'store/api/datahub'
import { AxiosBaseArgs } from 'store/api/shared'
import { IAdvisorRep, IDynamicsApiResult } from '../../../api/dynamics'

const paramsSerializer = (params: any) => {
  return queryString.stringify(params, { arrayFormat: 'comma' })
}

const domainApi = datahubApi.injectEndpoints({
  endpoints: (builder) => ({
    getDomainReps: builder.query<IAdvisorRep[] | undefined, void>({
      queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
        const baseRequest = {
          select: ['rcm_advisorrepid', 'rcm_repid', 'rcm_name'],
          $expand: [
            'rcm_OwningTeam($select=name;$expand=businessunitid($select=name;$expand=parentbusinessunitid($select=name;$expand=parentbusinessunitid($select=name;$expand=parentbusinessunitid($select=name)))))',
            'rcm_PersonalRepFor($select=domainname,fullname,_businessunitid_value,businessunitid)',
            'rcm_AdvisorRepPoolSplits_PoolRep_rcm_Advi($select=rcm_percentage,rcm_calc_poolrepname,rcm_calc_personalrepname,rcm_calc_poolrepid,rcm_calc_personalrepid;$filter=statecode eq 0)'
          ],
          $orderby: 'rcm_repid asc'
        } as IOdataRequest

        const rootUrl = 'D365Proxy/rcm_advisorreps'

        const baseApiArgs = {
          method: 'GET',
          url: rootUrl,
          params: baseRequest,
          paramsSerializer,
          headers: {
            Prefer: 'odata.maxpagesize=500'
          }
        } as AxiosBaseArgs

        type Response = QueryReturnValue<IDynamicsApiResult<IAdvisorRep>, Error>

        let current = (await baseQuery(baseApiArgs)) as Response

        let next = current?.data?.['@odata.nextLink']
        const chunks = [current]
        while (next) {
          const parsed = new URL(next)
          current = (await baseQuery({
            url: [rootUrl, parsed?.search].join(''),
            headers: {
              Prefer: 'odata.maxpagesize=500'
            }
          })) as Response
          chunks.push(current)
          next = current?.data?.['@odata.nextLink']
        }

        const error = chunks.find((chunk) => chunk?.error)
        if (error) {
          return { error: error.error }
        }

        return {
          data: chunks
            .map((chunk) => chunk?.data?.value)
            .filter(isNotNullOrUndefined)
            .flat()
        }
      },
      keepUnusedDataFor: 60 * 60 * 2
    })
  })
})

export const { useGetDomainRepsQuery } = domainApi
export const selectDomainRepsQueryResult =
  domainApi.endpoints.getDomainReps.select()
